const shopifyVideo = () => {
  const videoPosterSelector = document.querySelectorAll(
    '.video-section__poster',
  );
  videoPosterSelector.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.parentNode.classList.contains('shopify_hosted')) {
        this.parentNode.style.paddingBottom = '0px';
      }
    });
  });
  const shoifyHostedVideoSelector = document.querySelectorAll(
    '.shopify-hosted-autoplay',
  );
  shoifyHostedVideoSelector.forEach((item) => {
    item.parentNode.style.paddingBottom = '0px';
  });
};

export default shopifyVideo;
